// Переиспользуемый пагинатор для главных списков админки (серверная пагинация).
// props: total, limit, offset, onPage(newOffset)
export default function ListPager({ total, limit, offset, onPage }) {
  const pages = Math.max(1, Math.ceil(total / limit));
  const page = Math.floor(offset / limit) + 1;
  if (total <= limit) return null;

  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(offset + limit, total);

  return (
    <div style={s.bar}>
      <span style={s.info}>{from}–{to} из {total}</span>
      <div style={s.btns}>
        <button style={{ ...s.btn, ...(page <= 1 ? s.disabled : {}) }}
          onClick={() => page > 1 && onPage(offset - limit)} disabled={page <= 1}>← Назад</button>
        <span style={s.page}>{page} / {pages}</span>
        <button style={{ ...s.btn, ...(page >= pages ? s.disabled : {}) }}
          onClick={() => page < pages && onPage(offset + limit)} disabled={page >= pages}>Вперёд →</button>
      </div>
    </div>
  );
}

const s = {
  bar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 4px', color: '#94a3b8', fontSize: 13 },
  info: {},
  btns: { display: 'flex', alignItems: 'center', gap: 12 },
  btn: { background: '#1e293b', color: '#e2e8f0', border: '1px solid #334155', borderRadius: 8, padding: '7px 14px', fontSize: 13, cursor: 'pointer' },
  disabled: { opacity: 0.4, cursor: 'default' },
  page: { color: '#64748b' },
};
